<template>
    <transition name="fade">
        <div class="popup-overlay for-content" :class="{ 'active': active }"  @click.self="closePopup()">
            <transition name="fade">
                <div class="popup-main" :class="widthClass[size]">
                    <div class="popup-header-main">
                        <div class="popup-header">
                            <div class="popup-header-text" v-html="heading ?? ''"></div>
                            <button class="popup-close" aria-label="close" @click.prevent="closePopup()">&nbsp;</button>
                        </div>
                    </div>
                    <div
                        class="popup-content"
                        :class="{ 'no-padding' : ! padding }"
                        :data-content-reference="'popup-content[' + reference + ']'"
                    >
                        <slot></slot>
                    </div>
                    <div class="popup-footer">

                        <button
                            v-if="buttons && buttons.cancel"
                            @click.prevent="this.closePopup"
                            class="button cyan-clear rounded-lg mr-4 px-12"
                            v-html="buttons.cancel"
                        ></button>

                        <button
                            v-if="buttons && buttons.clear"
                            @click.prevent="emit('popup-handle-clear', this.reference)"
                            class="button cyan-clear rounded-lg mr-4 px-12"
                            v-html="buttons.clear"
                        ></button>

                        <button
                            v-if="buttons && buttons.apply"
                            @click.prevent="apply"
                            class="button rounded-lg xl:rounded-br-3xl cta"
                            v-html="buttons.apply"
                        ></button>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>

import {CancelableEvent} from "@/shared/plugins/Mitt.js";

export default {

    name: 'PopupForContent',

    props: ['reference', 'heading', 'options', 'buttons'],

    data() {
        return {
            isDocked: false,
            active: false,

            defaultSize: 5,
            size: 5,
            content: '',
            padding: true,
        }
    },

    created() {
        this.activeReference = this.reference;
        this.size = this.options && this.options.size !== undefined ? this.options.size : this.size;
        this.padding = this.options && this.options.padding !== undefined ? this.options.padding : this.padding;
    },

    mounted() {

        this.Bus.on('open-popup', (reference) => {
            if (reference === this.reference) {
                this.activate();
            }
        });

        this.Bus.on('close-popup', (reference) => {
            if (reference === this.reference) {
                this.deactivate();
            }
        });

        //look for the popup-active-content class. This class is used to initially hide the popup content, else the content
        //would be displayed already before the component is loaded. If found, add the active class.

        const popupActiveContent = document.querySelector('.popup-active-content[data-reference="' + this.reference + '"]');

        if (popupActiveContent) {
            popupActiveContent.classList.add('active');
        }

        //keys
        document.body.addEventListener('keydown', this.handleKeyDown);
    },

    methods: {

        apply() {
            this.Bus.emit('popup-handle-apply', this.reference)
        },

        activate() {
            this.scrollContentToTop();
            this.active = true;
            this.Bus.emit('set-popup-active-class');
        },

        deactivate() {
            this.active = false;
            this.Bus.emit('set-popup-inactive-class');
        },

        closePopup() {
            const event = new PopupEvent(this.reference);
            this.Bus.emit('popup-close', event);

            if (! event.cancelled) {
                this.deactivate();
                this.Bus.emit('hide-flash-message');
                this.Bus.emit('popup-closed', this.activeReference);
            }

        },

        handleKeyDown(event) {
            if (event.key === 'Escape') {
                this.closePopup();
            }
        },

        scrollContentToTop() {
            const popupContent = document.querySelector('.popup-content[data-content-reference="popup-content[' + this.reference + ']"]');
            popupContent.scrollTop = 0;
        },
    },

    computed: {
        widthClass() {
            return {
                1:      'max-w-xl',
                2:      'max-w-2xl',
                3:      'max-w-3xl',
                4:      'max-w-4xl',
                5:      'max-w-5xl',
                6:      'max-w-6xl',
                7:      'max-w-7xl',
                0:      '',
            };
        }
    }

};

class PopupEvent extends CancelableEvent {
    constructor(reference) {
        super();
        this.reference = reference;
    }
}

</script>
